<h1>Working on course {{course.title}}</h1>
<section>
    <form [formGroup]="chapterForm" (ngSubmit)="createChapter()">
    <section>Order/Roll number</section>
    <section><input type="text" formControlName="order" /></section>
    <section>Title</section>
    <section><input type="text" formControlName="title"/></section>
    <section>Description</section>
    <section><textarea cols="60" rows="10" formControlName="description"></textarea></section>
    <section><button type="submit">Add Chapter</button></section>
    </form>
</section>
<div *ngFor="let chapter of course?.chapters">
    <div>Chapter {{chapter?.order}}: <span class="chapter-title" (click)="navigate(chapter)">{{chapter?.title}}</span></div>
    <ul *ngFor="let lesson of chapter.lessons">
        <a href="#" appPreventDefault>Lesson {{lesson.order}}: <span class="chapter-title" (click)="navigateToLesson(lesson)">{{lesson.title}}</span></a>
    </ul>
</div>
